module.exports = __webpack_public_path__ + "static/business-phone-large-2af9856a84df4622a118317c651db36d.png";